import React from 'react';

export default function Card({ title, children, className = '' }) {
  return (
    <div className={`bg-white shadow-sm rounded-lg p-6 ${className}`}>      
      {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}
      {children}
    </div>
  );
}
